import { render } from "./PackageValidationRuleFilter.vue?vue&type=template&id=a83f51be&ts=true"
import script from "./PackageValidationRuleFilter.vue?vue&type=script&lang=ts"
export * from "./PackageValidationRuleFilter.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/trend/MANARATFOUNDATION/KRC-FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__